import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "category-open-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 6C2.25 4.48079 3.48079 3.25 5 3.25H9.471C10.0508 3.25 10.5915 3.53726 10.9168 4.01471L12.3221 6.0801C12.3683 6.14821 12.4462 6.19 12.529 6.19H19C20.5195 6.19 21.75 7.42203 21.75 8.94V18C21.75 19.5192 20.5192 20.75 19 20.75H5C3.48079 20.75 2.25 19.5192 2.25 18V6ZM5 4.75C4.30921 4.75 3.75 5.30921 3.75 6V18C3.75 18.6908 4.30921 19.25 5 19.25H19C19.6908 19.25 20.25 18.6908 20.25 18V8.94C20.25 8.24997 19.6905 7.69 19 7.69H12.529C11.9498 7.69 11.4072 7.40313 11.0815 6.92324L9.67719 4.85929C9.63046 4.7909 9.5531 4.75 9.471 4.75H5Z"
    }, null, -1)
  ])))
}
export default { render: render }